module.exports = __webpack_public_path__ + "img/GL.dc264d9e.png";